import { Box } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import { UserFilesSections } from "./enums/userSection"
import { UserListFiles } from "./components/main"
import { FilesManagerContext } from "../../../../context"
import { useTable } from "./hooks/tables"
import { UserDetailFile } from "./components/detail"
import { AddFile } from "./components/addFiles"
import { ViewFile } from "../../../detail/components/viewFile"


export const UserFiles = () => {

    const [section, setSection] = useState(UserFilesSections.LIST)
    const { filterListData, filterFileList } = useContext(FilesManagerContext)
    const { getData } = filterListData
    const [userId, setUserId] = useState<number | null>(null)
    const [user, setUser] = useState({ name: '', role: '', area: [''], department: [''], userType: '', })

    const handleUserDetail = (id: number, user: { name: string; role: string; area: string[]; department: string[]; userType: string; }) => {
        setUserId(id);
        setUser(user);
        setSection(UserFilesSections.DETAIL);
        tables.cleanData();
    }

    const tables = useTable({ handleUserDetail, setSection, filterFileList, userId, section })

    const goBackToList = () => {
        setSection(UserFilesSections.LIST)
        setUserId(null)
    }

    const goBackToUser = () => {
        if (userId) {
            tables.getUserFilesAlreadyAdded();
        }
        tables.cleanData()
        setSection(UserFilesSections.DETAIL)
    }

    const handleFilesList = () => {
        tables.getMyFilesList();
        setSection(UserFilesSections.ADD_FILE);
        tables.cleanData();
    }

    useEffect(() => {
        getData()
    }, [])

    const getSection = () => {
        let caseSection = <></>
        switch (section) {
            case UserFilesSections.LIST:
                caseSection =
                    <UserListFiles
                        rowList={tables.rowList}
                        columnList={tables.columnList}
                        filterFileList={filterFileList}
                        filterListData={filterListData}
                        tableLoading={tables.tableLoading}
                        totalPages={tables.totalPages}
                    />
                break
            case UserFilesSections.DETAIL:
                caseSection =
                    <UserDetailFile
                        handleFilesList={handleFilesList}
                        isChecked={tables.isChecked}
                        detailFilter={tables.detailFilter}
                        input={tables.input}
                        deletedUsersSelecteds={tables.deletedUsersSelecteds}
                        deleteSelected={tables.deleteSelected}
                        closeModal={tables.closeModal}
                        openModal={tables.openModal}
                        rowDetail={tables.rowDetail}
                        columnDetail={tables.columnDetail}
                        goBackToList={goBackToList}
                        saveUserList={tables.saveUserList}
                        unSelectOrSelectAllFiles={tables.unSelectOrSelectAllFiles}
                        user={user}
                        tableUserLoading={tables.tableUserLoading}
                        totalPagesDetail={tables.totalPagesDetail}
                        loadingDeleteFiles={tables.loadingDeleteFiles}
                        closeOpenSnakbar={tables.closeOpenSnakbar}
                        openSnackbar={tables.openSnackbar}
                        loadingSaveUserFiles={tables.loadingSaveUserFiles}
                        disabled={tables.disabledSaveUserFiles}
                    />
                break
            case UserFilesSections.ADD_FILE:
                caseSection =
                    <AddFile
                        goBackToUser={goBackToUser}
                        columnFileAdd={tables.columnAddFile}
                        input={tables.input}
                        rowFileAdd={tables.rowAddFile}
                        handleAddFiles={tables.handleAddFiles}
                        closeModal={tables.closeModal}
                        openModal={tables.openModal}
                        filterAddFiles={tables.filterAddFiles}
                        totalPagesAddFiles={tables.totalPagesAdd}
                        tableAddLoading={tables.tableAddLoading}
                        disabledAddFiles={tables.disabledAddFiles}
                        loadingSaveFiles={tables.loadingSaveFiles}
                    />
                break
            default:
                caseSection = <></>
        }

        return caseSection
    }

    return (
        <Box sx={{ minHeight: '70vh' }}>
            {getSection()}

            {tables.viewFile && (
                <ViewFile
                    fileKey={tables.viewFile.fileKey}
                    fileName={tables.viewFile.fileName}
                    setViewFile={tables.setViewFile}
                />
            )}
        </Box>
    )
}